<template>
    <OfflineScreen v-if="isSupported && !isOnline" />
    <LoadingScreen v-else-if="auth.initializing" />
    <template v-else-if="route.path === '/test'">
        <RouterView />
    </template>
    <template v-else>
        <MenuLayout v-if="auth.loggedIn">
            <router-view :key="route.fullPath" />
        </MenuLayout>
        <BasicLayout v-else-if="!['/login', '/register', '/select-username'].includes(route.path)">
            <router-view />
        </BasicLayout>
        <router-view v-else />
    </template>
    <!-- The app is dark-only (body.dark in index.html); sonner defaults to light
         and its own stylesheet is unlayered, so it wins over Tailwind utilities
         under v4's cascade layers. Telling it the theme is the way to match. -->
    <Toaster position="top-right" theme="dark" close-button />
    <PwaUpdatePrompt />
</template>

<script setup lang="ts">
import { useNetwork } from "@vueuse/core";
import { RouterView } from "vue-router";
import { useRoute } from "vue-router/auto";
import LoadingScreen from "./components/core/LoadingScreen.vue";
import OfflineScreen from "./components/core/OfflineScreen.vue";
import PwaUpdatePrompt from "./components/core/PwaUpdatePrompt.vue";
import { Toaster } from "./components/ui/sonner";
import BasicLayout from "./layouts/BasicLayout.vue";
import MenuLayout from "./layouts/MenuLayout.vue";
import { useAuthStore } from "./stores/auth";

const route = useRoute();
const auth = useAuthStore();

const { isSupported, isOnline } = useNetwork();

</script>
